import { Table, Badge } from 'reactstrap';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import { Trans } from 'react-i18next';

class UserActionsTable extends Component {
  render() {
    return (
      <div>
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <Table striped bordered style={{ minWidth: '800px' }}>
            <thead>
              <tr>
                <th></th>
                <th hidden>ID</th>
                <th>
                  <Trans i18nKey="userActions.IP" />
                </th>
                <th>
                  <Trans i18nKey="userActions.USER" />
                </th>
                <th>
                  <Trans i18nKey="userActions.CREATED" />
                </th>
                <th>
                  <Trans i18nKey="userActions.METHOD_TYPE" />
                </th>
                <th>
                  <Trans i18nKey="userActions.ACTION" />
                </th>
                <th>
                  <Trans i18nKey="userActions.RESULT_STATUS_CODE" />
                </th>
                <th>
                  <Trans i18nKey="userActions.DURATION" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.props.userActions.map((userAction, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{userAction.ip}</td>
                  <td>
                    {userAction.userName +
                      ', ' +
                      userAction.userFirstName +
                      ' ' +
                      userAction.userLastName +
                      ', Id: ' +
                      userAction.userId}
                  </td>
                  <td>{moment.utc(userAction.created).local().format('lll')}</td>
                  <td>{this.composePillColor(userAction.method)}</td>
                  <td>{userAction.controller + ' -> ' + userAction.action}</td>
                  <td>{userAction.resultStatusCode}</td>
                  <td>{userAction.durationMiliseconds}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  composePillColor(method) {
    if (method.toLowerCase() === 'get') {
      return <Badge color="success">{method}</Badge>;
    } else if (method.toLowerCase() === 'delete') {
      return <Badge color="danger">{method}</Badge>;
    } else if (method.toLowerCase() === 'put') {
      return <Badge color="warning">{method}</Badge>;
    } else {
      return <Badge color="primary">{method}</Badge>;
    }
  }
}

export default withRouter(UserActionsTable);
